<template>
  <router-view />
</template>

<script>
// @ is an alias to /src

export default {
  name: "Detail",
  components: {
    // Lightbox
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
